import React from "react"
import { SEOHead } from "components/SEO"
import CustomizableAnalyticsSection from "components/pages/use-cases/customer-apps/CustomizableAnalyticsSection"
import HeroSection from "components/pages/use-cases/customer-apps/HeroSection"
import SingleCTASection from "components/pages/use-cases/customer-apps/SingleCTASection"
import TimeToMarketSection from "components/pages/use-cases/customer-apps/TimeToMarketSection"
import TotalCostOfOwnershipSection from "components/pages/use-cases/customer-apps/TotalCostOfOwnershipSection"
import UserEngagementSection from "components/pages/use-cases/customer-apps/UserEngagementSection"
import DividerSection from "components/ui/Blocks/DividerSection"
import Layout from "components/ui/Layout"

function CustomersApps({ location: { pathname } }) {
  return (
    <Layout
      contentSpaced
      trackingName="Use Cases - Customer Apps"
      pageName="customer-apps"
      pagePath={pathname}
    >
      <HeroSection />
      <div>
        <TotalCostOfOwnershipSection className="lg:-mt-10 2xl:mt-0" />
        <TimeToMarketSection />
        <CustomizableAnalyticsSection className="-my-20 2xl:-my-24" />
        <UserEngagementSection />
      </div>
      <DividerSection />
      <SingleCTASection />
    </Layout>
  )
}

// Export a Head component for Gatsby Head API
export function Head() {
  return (
    <SEOHead
      title="Embed Data Visualizations in Customer Facing Applications"
      description="Share data with your customers by embedding analytics directly into your customer-facing application, product, or service with Preset."
    />
  )
}

export default CustomersApps
